module.exports = __webpack_public_path__ + "img/three2Orange.2c094099.jpg";